import React, { useState, useCallback } from 'react';

import { Button, Flexer, Text, Spacer } from '@ontruck/orc';

import { Loading } from 'components/Loading';

import { ModalStyled, ContainerStyled, ContentStyled, ScrollStyled, FooterStyled } from './styled';

import JourneyOfferDriver from './JourneyOfferDriver';
import { useOfferAcceptedDrivers, usePostSelectedDrivers } from './hooks';

const t = {
  no_data: 'No data',
  one_job: 'job',
  other_job: 'jobs',
  offer_job: 'Offer job',
};

const offerJobsEnabled = true;

const JourneyOfferStatsModal = ({ journeyId, onClose, title }) => {
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedDriversToPost, setSelectedDriversToPost] = useState([]);

  const { loading, drivers } = useOfferAcceptedDrivers(journeyId);
  const { posting, isError, isOk } = usePostSelectedDrivers(journeyId, selectedDriversToPost);

  const onSubmitClicked = useCallback(() => {
    setSelectedDriversToPost(selectedDrivers);
  }, [selectedDrivers]);

  const onSelect = useCallback(
    (e, { name: driverId, value }) => {
      if (value) {
        setSelectedDrivers([...selectedDrivers, driverId]);
        return;
      }
      setSelectedDrivers([...selectedDrivers.filter((id) => id !== driverId)]);
    },
    [selectedDrivers, setSelectedDrivers]
  );

  return (
    <ModalStyled show onClose={onClose} headerComponent={title} withPadding={false}>
      <ContainerStyled>
        <ContentStyled flexDirection="column">
          {isOk && (
            <Spacer m="S">
              <Text display="block" color="success700">
                Success!
              </Text>
            </Spacer>
          )}
          {isError && (
            <Spacer m="S">
              <Text display="block" color="error700">
                Error has occured!
              </Text>
            </Spacer>
          )}
          <ScrollStyled p="S" flex="1">
            {loading && (
              <Flexer.Parent alignItems="center" justifyContent="center">
                <Loading />
              </Flexer.Parent>
            )}
            {!loading &&
              drivers.map((driver) => (
                <JourneyOfferDriver
                  key={driver.id}
                  driver={driver}
                  onSelect={onSelect}
                  showCheckbox={offerJobsEnabled}
                />
              ))}
            {!loading && !drivers.length && (
              <Flexer.Parent justifyContent="center">{t.no_data}</Flexer.Parent>
            )}
          </ScrollStyled>
          {offerJobsEnabled && (
            <FooterStyled p="S">
              <Button
                onClick={onSubmitClicked}
                text={t.offer_job}
                fullWidth
                disabled={!selectedDrivers.length || posting}
              />
            </FooterStyled>
          )}
        </ContentStyled>
      </ContainerStyled>
    </ModalStyled>
  );
};

export default JourneyOfferStatsModal;
